/**
 * Tiny shared store for the demo-form link with the player's numbers. The calculator root publishes it; the static prose
 * CTAs (server-rendered with the plain link) read it after hydration. The base string is duplicated from engine/roi-url.ts
 * on purpose: importing that file would pull the whole engine into the page's main bundle.
 */
export const BASE_FORM_HREF = '/mortgage-lead-generation-demo?ref=roi-calculator';

let current = BASE_FORM_HREF;
const subs = new Set<() => void>();

export const getRoiFormHref = () => current;
export const getRoiFormHrefServer = () => BASE_FORM_HREF;
export function setRoiFormHref(h: string) {
  if (h === current) return;
  current = h;
  subs.forEach((f) => f());
}
export function subscribeRoiFormHref(f: () => void) {
  subs.add(f);
  return () => { subs.delete(f); };
}
